import styled from 'styled-components/macro';

export const SwitchWrapper = styled.div`
  z-index: 1;
  display: inline-block;
  position: relative;
`;
